// customizzato blocco argomenti in evidenza
// per background immagine personalizzato
// - Background

import React from 'react';

const Background = (props) => {
  return (
    <div className="argumentInEvidence-background" {...props}>
      <div className="img-responsive-wrapper">
        <div className="img-responsive img-responsive-panoramic">
          <figure className="img-wrapper">
            {props?.image && (
              <img
                src={`data:${props?.image['content-type']};${props?.image?.encoding},${props?.image?.data}`}
                alt="imgalt"
                title="imgtitle"
                style={{ height: '300px' }}
              ></img>
            )}
          </figure>
        </div>
      </div>
    </div>
  );
};

export default Background;
